import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

import { AuthService } from '../_services/auth.service';


@Injectable()
export class AuthGuard implements CanActivate {
    constructor(
        private authService: AuthService,
        private router: Router
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        if (this.authService.isAuthenticated()) {
            return true;
        }

        const url = state.url;
        this.authService.redirectUrl = url;
        this.router.navigate(['/']);

        return false;
    }
}



// WEBPACK FOOTER //
// ./src/app/_guards/auth.guard.ts